import * as React from 'react';
import { IValidationConfig, IOperator, IConditionConfig, IQueryBuilderConfigRule, QueryBuilderHelper, EOutputLookupContext,
    EValidationContext  } from '../../helpers';
import { OUTPUT_DROPDOWN_DEFAULT } from '../../constants';
import { QueryBuilder,ContentEditableTinyMCE } from '../';
import {TextField, Button, ButtonType, IDropdownOption, Label, Dropdown, Toggle } from 'office-ui-fabric-react';

interface IProps {
    validationItem: IValidationConfig;
    operators: IOperator[];
	operatorTypes: string[];
    outputOptions: IDropdownOption[];
    defaultOutputOption: IDropdownOption;
    validationContext: EValidationContext;
    updateEditedValidationItem: (validationItem: IValidationConfig) => void;
    saveButtonClick: () => void;
    cancelButtonClick: () => void;
}

const VALIDATION_CONDITION_EDITOR_ID = 'validation_condition_editor';

export class ValidationItemEdit extends React.Component<IProps, any> {

    private nameChange = (validationName: string) => {
        let { validationItem, updateEditedValidationItem } = this.props;

        validationItem.ValidationName = validationName;

        updateEditedValidationItem(validationItem);
    }

    private messageChange = (validationMessage: string) => {
        let { validationItem, updateEditedValidationItem } = this.props;

        validationItem.ValidationMessage = validationMessage;

        updateEditedValidationItem(validationItem);
    }

    private validationConfigChange = (validationConfig: IConditionConfig) => {
        let { validationItem, updateEditedValidationItem } = this.props;

        validationItem.ValidationConfig = validationConfig;

        updateEditedValidationItem(validationItem);
    }

    private raiseErrorIfChange = (selectedOption: IDropdownOption) => {
        let { validationItem, updateEditedValidationItem } = this.props;

        validationItem.RaiseErrorIfConditionIs = !!selectedOption.key;

        updateEditedValidationItem(validationItem);
    }

    private applyIfControlIsEmptyChange = (applyIfControlIsEmpty: boolean) => {
        let { validationItem, updateEditedValidationItem } = this.props;
        
        validationItem.ApplyIfControlIsEmpty = applyIfControlIsEmpty;
        
        updateEditedValidationItem(validationItem);
    }

    public render() {

        let { validationItem, operators, operatorTypes, outputOptions, defaultOutputOption, updateEditedValidationItem, 
            saveButtonClick, cancelButtonClick, validationContext } = this.props;

        let isEmptyLabel: string = ""; 
        switch(validationContext) {

            case EValidationContext.Control:
                isEmptyLabel = "Apply this validation rule if the control is empty?";
                break;
            case EValidationContext.Loop:
                isEmptyLabel = "Apply this validation rule if the loop has no items?";
                break;
            default:
                break;

        }

        //add blank option to the top of dropdownOptions
        let queryBuilderOutputOptions:IDropdownOption[] = [OUTPUT_DROPDOWN_DEFAULT];
        queryBuilderOutputOptions = queryBuilderOutputOptions.concat(outputOptions);
        let defaultQueryBuilderOutputOption: IDropdownOption = defaultOutputOption;

        return (<div className="validation-item-edit-wrapper">
            <Label>Name</Label>
            <TextField
                label={ null } 
                value={ validationItem.ValidationName }
                onChanged={ this.nameChange }
            />
            <Label>Validation Message</Label>
            <ContentEditableTinyMCE
                label={null } 
                value={ validationItem.ValidationMessage }
                onBlur= {
                    (val) => this.messageChange(val)
                  }
                outputOptions={ queryBuilderOutputOptions }
                singleLine={true}
                richText={false}
                readonly={false}
                outputLookupContext={EOutputLookupContext.NotSpecified}
            />
            <Dropdown 
                options={[{key: 1, text: "True"}, {key: 0, text: "False"}]}
                label={'Raise error if condition is'}
                selectedKey={validationItem.RaiseErrorIfConditionIs ? 1 : 0}
                onChanged={ this.raiseErrorIfChange }
            />
            <Toggle 
                checked={validationItem.ApplyIfControlIsEmpty} 
                label={isEmptyLabel}
                onChanged={this.applyIfControlIsEmptyChange}
            />
            <QueryBuilder 
                queryBuilderConfig={validationItem.ValidationConfig} 
                propertyOptions={queryBuilderOutputOptions || []} 
                defaultOption={defaultQueryBuilderOutputOption}
                id={VALIDATION_CONDITION_EDITOR_ID} 
                outputLookupContext={EOutputLookupContext.ControlValidationConfig}
                onChange={this.validationConfigChange}
            />
            <Button
                className='branch-cancel-button'
                buttonType={ ButtonType.normal }
                onClick={cancelButtonClick}
            >Cancel</Button>
            <Button
                className='branch-save-button'
                buttonType={ ButtonType.primary }
                onClick={() => {
                    QueryBuilderHelper.validateQueryBuilder(VALIDATION_CONDITION_EDITOR_ID);
                    saveButtonClick();
                }}
            >Save</Button>
        </div>);

    }

}


// WEBPACK FOOTER //
// ./source/ts/components/validation/validation-item-edit.tsx